/*
 *
 * DivisionEdit constants
 *
 */
export const GET_LANGUAGE_WATCHER = "app/DivisionEdit/GET_LANGUAGE_WATCHER"
export const GET_LANGUAGE_SUCCESS = "app/DivisionEdit/GET_LANGUAGE_SUCCESS"
export const GET_LANGUAGE_FAILED = "app/DivisionEdit/GET_LANGUAGE_FAILED"

export const GET_DIVISION_WATCHER = "app/DivisionEdit/GET_DIVISION_WATCHER"
export const GET_DIVISION_SUCCESS = "app/DivisionEdit/GET_DIVISION_SUCCESS"
export const GET_DIVISION_FAILED = "app/DivisionEdit/GET_DIVISION_FAILED"

export const GET_HISTORY_WATCHER = "app/DivisionEdit/GET_HISTORY_WATCHER"
export const GET_HISTORY_SUCCESS = "app/DivisionEdit/GET_HISTORY_SUCCESS"
export const GET_HISTORY_FAILED = "app/DivisionEdit/GET_HISTORY_FAILED"

export const GET_CHILDREN_DIVISION_WATCHER =
  "app/DivisionEdit/GET_CHILDREN_DIVISION_WATCHER"
export const GET_CHILDREN_DIVISION_SUCCESS =
  "app/DivisionEdit/GET_CHILDREN_DIVISION_SUCCESS"
export const GET_CHILDREN_DIVISION_FAILED =
  "app/DivisionEdit/GET_CHILDREN_DIVISION_FAILED"

export const GET_DIVISION_PARENTS_WATCHER =
  "app/DivisionEdit/GET_DIVISION_PARENTS_WATCHER"
export const GET_DIVISION_PARENTS_SUCCESS =
  "app/DivisionEdit/GET_DIVISION_PARENTS_SUCCESS"
export const GET_DIVISION_PARENTS_FAILED =
  "app/DivisionEdit/GET_DIVISION_PARENTS_FAILED"

export const GET_SUBDIVISIONS_WIHOUT_PARENT_WATCHER =
  "app/DivisionEdit/GET_SUBDIVISIONS_WIHOUT_PARENT_WATCHER"
export const GET_SUBDIVISIONS_WIHOUT_PARENT_SUCCESS =
  "app/DivisionEdit/GET_SUBDIVISIONS_WIHOUT_PARENT_SUCCESS"
export const GET_SUBDIVISIONS_WIHOUT_PARENT_FAILED =
  "app/DivisionEdit/GET_SUBDIVISIONS_WIHOUT_PARENT_FAILED"

export const DELETE_DIVISION_WATCHER =
  "app/DivisionEdit/DELETE_DIVISION_WATCHER"
export const DELETE_DIVISION_SUCCESS =
  "app/DivisionEdit/DELETE_DIVISION_SUCCESS"
export const DELETE_DIVISION_FAILED = "app/DivisionEdit/DELETE_DIVISION_FAILED"

export const ADD_SUBDIVISION_WATCHER =
  "app/DivisionEdit/ADD_SUBDIVISION_WATCHER"
export const ADD_SUBDIVISION_SUCCESS =
  "app/DivisionEdit/ADD_SUBDIVISION_SUCCESS"
export const ADD_SUBDIVISION_FAILED = "app/DivisionEdit/ADD_SUBDIVISION_FAILED"

export const DELETE_SUBDIVISION_WATCHER =
  "app/DivisionEdit/DELETE_SUBDIVISION_WATCHER"
export const DELETE_SUBDIVISION_SUCCESS =
  "app/DivisionEdit/DELETE_SUBDIVISION_SUCCESS"
export const DELETE_SUBDIVISION_FAILED =
  "app/DivisionEdit/DELETE_SUBDIVISION_FAILED"

export const UPDATE_NAME_DIVISION_WATCHER =
  "app/DivisionEdit/UPDATE_NAME_DIVISION_WATCHER"
export const UPDATE_NAME_DIVISION_SUCCESS =
  "app/DivisionEdit/UPDATE_NAME_DIVISION_SUCCESS"
export const UPDATE_NAME_DIVISION_FAILED =
  "app/DivisionEdit/UPDATE_NAME_DIVISION_FAILED"

// CHANGE SELECT SUPERIOR
export const CHANGE_SELECT_SUPERIOR_WATCHER =
  "app/DivisionEdit/CHANGE_SELECT_SUPERIOR_WATCHER"
export const CHANGE_SELECT_SUPERIOR_SUCCESS =
  "app/DivisionEdit/CHANGE_SELECT_SUPERIOR_SUCCESS"
export const CHANGE_SELECT_SUPERIOR_FAILED =
  "app/DivisionEdit/CHANGE_SELECT_SUPERIOR_FAILED"

// UP_LEVEL_ONE_WATCHER
export const UP_LEVEL_ONE_WATCHER = "app/DivisionEdit/UP_LEVEL_ONE_WATCHER"
export const UP_LEVEL_ONE_SUCCESS = "app/DivisionEdit/UP_LEVEL_ONE_SUCCESS"
export const UP_LEVEL_ONE_FAILED = "app/DivisionEdit/UP_LEVEL_ONE_FAILED"

export const GET_COLLABORATORS_DIVISION_WATCHER =
  "app/DivisionEdit/GET_COLLABORATORS_DIVISION_WATCHER"
export const GET_COLLABORATORS_DIVISION_SUCCESS =
  "app/DivisionEdit/GET_COLLABORATORS_DIVISION_SUCCESS"
export const GET_COLLABORATORS_DIVISION_FAILED =
  "app/DivisionEdit/GET_COLLABORATORS_DIVISION_FAILED"

export const GET_EMPLOYEES_DIVISIONS_WATCHER =
  "app/ControlPanelUserManagementAmbassador/GET_EMPLOYEES_DIVISIONS_WATCHER"
export const GET_EMPLOYEES_DIVISIONS_SUCCESS =
  "app/ControlPanelUserManagementAmbassador/GET_EMPLOYEES_DIVISIONS_SUCCESS"
export const GET_EMPLOYEES_DIVISIONS_FAILED =
  "app/ControlPanelUserManagementAmbassador/GET_EMPLOYEES_DIVISIONS_FAILED"
